import { Injectable } from '@angular/core';
import { ListService } from 'bookraw/shared/services/list.service';
import { Partner } from 'bookraw/shared/models/partner.model';
import { environment } from 'env/environment';
import { ItemResponse } from 'bookraw/shared/models/api/item.response';

@Injectable()
export class PartnersService extends ListService<Partner> {

  url: string = '/api/admin/partners';

  getBySlug(slug: string ) {
    return this.http.get<ItemResponse<Partner>>(environment.baseURL + this.url + '/byAlias/' + slug);
  }

  addPartner(id: number, data: object) {
    return this.http.put<ItemResponse<Partner>>(environment.baseURL + this.url + '/' + id, data);
  }
}
